import React from "react";
import _ from "lodash";
import { NavLink, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getStudentDetail, captureRazorPayment, createRazorpayOrder } from "../../actions";
import StyleConstants from "../../shared/constants/styleConstants/styles.json";
import avatar from "../../shared/images/common/avatar.png";
import { convertToCurrencyFormat, toTitleCase, isToday } from "../../helpers/Utils";
import moment from "moment";
import {
  changePaymentAmountForDue,
  performSplitUpForExternal,
  PAYMENT_TYPES,
  REFUND_PAYMENT_TYPES,
} from "../../actions";
import tickMark from "../../shared/images/common/tick_mark.png";
import Receipt from "../feeCollection/receipt";
import ReactToPrint from "react-to-print";
import Modal from "react-responsive-modal";
import numberToWords from "number-to-words";
import IbLogo from '../../shared/images/common/IB.png';
import Constants from '../../shared/constants/environmentConfig';
class ExternalFeePaymentPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentConfirmationState: false,
      paymentAmount: 0,
      refundTotalDetails: [],
      errorMessage: '',
      errorConfirmMessage: '',
      showConfirmationModal: false,
      confirmationPaymentAmount: 0,
      studentId: 0,
      instituteId: 0,
    };
  }

  componentDidMount() {
    const instituteId = this.props.match.params.institute_id;
    const studentId = this.props.selectedStudentId ? this.props.selectedStudentId : this.props.match.params.student_id;
    this.props.getStudentDetail(studentId, instituteId).then(() => {
      const { refundDetails } = this.props;
      const refundTotalDetail = {};
      Object.values(refundDetails).map((refund) => {
        refundTotalDetail[refund.fee_dues_id] =
          (refundTotalDetail[refund.fee_dues_id] || 0) + refund.amount;
      });
      this.setState({
        refundTotalDetails: { ...refundTotalDetail }, studentId: this.props.selectedStudentId, instituteId: this.props.instituteId
      });
    });
  }

  renderPaymentSuccessful() {
    const { feePaid, institute, transactionId, studentData, selectedPaymentDate } = this.props;
    let filteredFeeDues = feePaid.filter(
      (fee) => fee.transaction_id == transactionId
    );
    const feeGroups = filteredFeeDues.reduce((groups, item) => {
      const group = groups[item.fee_account_id] || [];
      group.push(item);
      groups[item.fee_account_id] = group;
      return groups;
    }, {});

    return (
      <>
        <div
          className="hide-in-print"
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <div
            style={{
              fontSize: 30,
              marginRight: 20,
              color: StyleConstants.color.darkBlue,
              fontWeight: "400",
            }}
          >
            {"Payment Successful"}
          </div>
          <img
            src={tickMark}
            alt=""
            style={{ height: 20, width: 20, cursor: "pointer" }}
            onClick={() => {}}
          />
        </div>
        <div
          className="hide-in-print"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            className="Button Secondary-Button"
            style={{
              width: 200,
              margin: "40px 15px 40px 0px",
              height: 45,
              fontSize: 18,
            }}
            onClick={() => 
              window.location.reload()
            }
          >
            Done
          </div>
          {
            <ReactToPrint
              trigger={() => {
                return (
                  <div
                    className="Button Primary-Button"
                    style={{
                      width: 200,
                      margin: "40px 0px",
                      height: 45,
                      fontSize: 18,
                    }}
                  >
                    Download
                  </div>
                );
              }}
              content={() => this.componentRef}
            />
          }
        </div>
        {(
          <div className="printable">
            <div ref={(el) => (this.componentRef = el)}>
              {Object.values(feeGroups).map((feeGroup, index) => {
                return (
                  <Receipt
                    key={Number(Object.keys(feeGroups)[index])}
                    feeGroup={feeGroup}
                    receipt={feeGroup[0].receipt_number}
                    studentData={studentData}
                    isRazor={true}
                    institute={institute}
                    feeAccountID={Number(Object.keys(feeGroups)[index])}
                    paymentDate={selectedPaymentDate.format("DD-MMM-YYYY")}
                  />
                );
              })}
            </div>
          </div>
        )}
      </>
    );
  }


  onPaymentProceed = (confirmationPaymentAmount) => {
    const { createRazorpayOrder } = this.props;
    const { studentId } = this.state;
    createRazorpayOrder(studentId,confirmationPaymentAmount).then(response => {
      if (response.success) {
        this.payment(confirmationPaymentAmount);
        return;
      }
    });
  };




  payment(amount) {
    const { captureRazorPayment, studentData, selectedPaymentDate } = this.props;
    const { studentId, instituteId } = this.state;
    const options = {
      key: Constants().razorPayPublicKey,
      amount: Math.ceil(amount * 100),
      name: studentData.first_name,
      image: IbLogo,
      handler(response) {
        captureRazorPayment(response, amount, selectedPaymentDate, studentId, instituteId);
      },
      prefill: {
        name: studentData.first_name,
        email: studentData.email,
      },
      theme: {
        color: "blue",
      },
    };
    const rzp = new window.Razorpay(options);
    rzp.open();
    rzp.on('payment.failed', this.props.onPaymentFailure);
  }

  renderfees() {
    let totalFeeDue = 0;
    let totalPayment = 0;
    const { feeDues } = this.props;
    const { errorMessage } = this.state;
    const {
      paymentConfirmationState,
      refundTotalDetails,
    } = this.state;
    const showPayment = paymentConfirmationState;
    if (!_.isEmpty(feeDues)) {
      if (showPayment) {
        totalPayment = feeDues.reduce(
          (sum, fee) => sum + (parseInt(fee.payment, 10) || 0),
          0
        );
      } else {
        totalFeeDue = feeDues.reduce(
          (sum, fee) => sum + (parseInt(fee.balance, 10) || 0),
          0
        );
      }
    }
    let filteredFeeDues = false
      ? feeDues.filter((fee) => Number(fee.payment) !== 0)
      : feeDues;
    
    filteredFeeDues = [...filteredFeeDues.sort((a, b) => {
        if (
          a.priority <
          b.priority
        )
          return 1;
        if (
          a.priority >
          b.priority
        )
          return -1;
        if (a.fee_due_id < b.fee_due_id) return 1;
        if (a.fee_due_id > b.fee_due_id) return -1;
    })
    ];
    
    return (
      <>
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 20px;
            font-weight: normal;
            font-size:14;
            text-align:left;
          }
          td {
            padding: 20px;
            text-align: center;
          }
        `}
        </style>
        <div
          style={{
            flex: 1,
            margin: "20px 10px",
            paddingLeft: 50,
          }}
        >
          {(
            <div
              style={{
                fontWeight: "bold",
                marginBottom: 10,
                color: "#005060",
                fontSize: 18,
              }}
            >
              Dues
            </div>
          )}
          <div
            style={{
              flex: 1,
              padding: 0,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#ffffff",
              boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: 20,
              }}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    color: StyleConstants.color.darkBlue,
                    fontWeight: "300",
                    marginRight: 10,
                    fontSize: 16,
                  }}
                >
                  Enter Amount:
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div>₹</div>
                  <input
                    type="string"
                    autoFocus={true}
                    value={convertToCurrencyFormat(
                      this.state.paymentAmount,
                      ""
                    )}
                    style={{
                      border: "1px solid gray",
                      fontSize: 16,
                      marginLeft: 3,
                    }}
                    onChange={(event) => {
                      const amount =
                        parseInt(event.target.value.replaceAll(",", ""), 10) ||
                        0;
                      this.setState({
                        errorMessage: "",
                        paymentAmount: amount,
                      });
                      this.props
                        .performSplitUpForExternal(amount, refundTotalDetails, feeDues)
                        .then((error) => {
                          if (error) {
                            this.setState({ errorMessage: error });
                          }
                        });
                    }}
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: 20,
                }}
              >
                <div
                  style={{
                    color: StyleConstants.color.darkBlue,
                    fontWeight: "300",
                    marginRight: 10,
                    fontSize: 16,
                  }}
                  value={this.props.selectedPaymentDate.format("YYYY-MM-DD")}
                  onChange={(event) => this.props.updateSelectedDate(event.target.value)}
                >
                  Payment Date:{" "}
                </div>
                <input
                  type="date"
                  style={{
                    border: "1px solid gray",
                  }}
                  value={this.props.selectedPaymentDate.format("YYYY-MM-DD")}
                  onChange={(event) => this.props.updateSelectedDate(event.target.value)}
                />
              </div>
            </div>
            {errorMessage && (
              <div
                style={{
                  color: "red",
                  margin: "10px 0",
                  textAlign: "center",
                }}
              >
                {errorMessage}
              </div>
            )}
            <table>
              <thead
                style={{
                  background: "#edf1f8",
                  color: StyleConstants.color.darkBlue,
                }}
              >
                <tr>
                  <th>Due Date</th>
                  <th>Fee</th>
                  {<th>Amount</th>}
                  <th>Balance</th>
                  {<th>Payment</th>}
                </tr>
              </thead>
              <tbody style={{ color: "#6f6f6f" }}>
                {filteredFeeDues.map((feeDue) => {
                  return (
                    <>
                      <tr key={feeDue.id}>
                        <td style={{ textAlign: "left" }}>
                          {moment(feeDue.due_date).format("DD MMM 'YY")}
                        </td>
                        <td style={{ textAlign: "left" }}>{feeDue.name}</td>
                        {(
                          <td style={{ textAlign: "left" }}>
                            {convertToCurrencyFormat(feeDue.total_amount)}
                          </td>
                        )}
                        <td style={{ textAlign: "left" }}>
                          {refundTotalDetails[feeDue.fee_due_id]
                            ? convertToCurrencyFormat(
                                feeDue.balance +
                                  refundTotalDetails[feeDue.fee_due_id]
                              )
                            : convertToCurrencyFormat(feeDue.balance)}
                        </td>
                        {(
                          <td style={{ textAlign: "left" }}>
                            {feeDue.payment ? convertToCurrencyFormat(feeDue.payment): convertToCurrencyFormat(0)}
                          </td>
                        )}
                      </tr>
                      
                    </>
                  );
                })}
              </tbody>
            </table>
            <div
              style={{
                flex: 1,
                display: "flex",
                fontWeight: "300",
                borderTop: "1px dashed #c8c8c8",
                padding: "15px 50px 10px 10px",
                justifyContent: "right",
                color: StyleConstants.color.darkBlue,
              }}
            >
              <div>Total:</div>
              <div>
                {"  "}
                {convertToCurrencyFormat(
                  this.state.paymentAmount
                )}
              </div>
            </div>
          </div>
        </div>
        </>
        );
  }

  renderConfirmationModal() {
    const { showLoader, showRefunds, confirmationPaymentAmount } = this.state;
    return (
      <Modal
        center
        open={this.state.showConfirmationModal}
        onClose={() => this.setState({ showConfirmationModal: false })}
      >
        <div style={{ padding: 30, fontFamily: "'Poppins', sans-serif" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                color: StyleConstants.color.darkBlue,
                fontWeight: "400",
                marginRight: 10,
                fontSize: 20,
              }}
            >
              Amount in words:
            </div>
            <div
              style={{
                textAlign: "right",
                display: "flex",
                alignItems: "center",
                fontSize: 17,
                fontWeight: 300,
              }}
            >
              {toTitleCase(numberToWords.toWords(this.state.paymentAmount))}
            </div>
          </div>
          <div style={{ marginTop: 20, display: "flex", alignItems: "center" }}>
            <div
              style={{
                color: StyleConstants.color.darkBlue,
                fontWeight: "400",
                marginRight: 10,
                fontSize: 20,
              }}
            >
              Enter Total Amount:
            </div>
            <div
              style={{
                textAlign: "right",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div>₹ </div>
              <input
                type="string"
                value={convertToCurrencyFormat(
                  this.state.confirmationPaymentAmount,
                  ""
                )}
                style={{
                  border: "none",
                  borderBottom: "1px solid gray",
                  fontSize: 20,
                }}
                onChange={(event) => {
                  this.setState({
                    confirmationPaymentAmount:
                      parseInt(event.target.value.replaceAll(",", ""), 10) || 0,
                  });
                }}
              />
            </div>
          </div>
          {!!this.state.errorConfirmMessage && (
            <div style={{ color: "red", marginTop: 10 }}>
              {this.state.errorConfirmMessage}
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
          }}
        >
          <div
            className="Button Secondary-Button"
            style={{ width: 100, marginRight: 10 }}
            onClick={() => this.setState({ showConfirmationModal: false })}
          >
            Cancel
          </div>
          {
            <div
              style={{ width: 100, color: "white" }}
              className="Button Primary-Button"
              onClick={() => {
                if (
                  confirmationPaymentAmount !==
                  this.state.paymentAmount
                ) {
                  this.setState({ errorConfirmMessage: "Please check the amount", showLoader: true });
                  return;
                }
                this.onPaymentProceed(confirmationPaymentAmount);
              }}
            >
              Confirm
            </div>
          }
        </div>
      </Modal>
    );
  }

  renderConfirmButton() {
    return (
      <div
        style={{
          flex: 1,
          display: "flex",
          margin: "30px 0px",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="Button Secondary-Button"
          onClick={() =>
            this.setState({
              paymentConfirmationState: false,
            })
          }
          style={{
            width: 200,
            marginRight: 15,
          }}
        >
          Cancel
        </div>
        <div
          className="Button Primary-Button"
          onClick={() => this.setState({ showConfirmationModal: true })}
          style={{ width: 200 }}
        >
          Confirm
        </div>
      </div>
    );
  }
  
  renderMakePaymentButton() {
    const { errorMessage } = this.state;
    const isInvalid = errorMessage && errorMessage.length > 1;
    return (
      <div
        style={{
          display: "flex",
          flex: 1,
          justifyContent: "right",
          alignItems: "center",
          height: 55,
        }}
      >
        <div
          className="Button Primary-Button"
          onClick={() => !isInvalid && this.setState({ showConfirmationModal: true })}
          style={{
            width: 200,
            backgroundColor: StyleConstants.color.darkBlue,
            opacity: isInvalid ? 0.5 : 1,
          }}
        >
          Make Payment
        </div>
      </div>
    );
  }

  renderTransactions() {
    const { feePaid, refundDetails } = this.props;
    const totalAmount = feePaid.reduce(
      (totalAmount, item) => totalAmount + item.amount,
      0
    );
    const transactions = feePaid.reduce((transactions, item) => {
      const transaction = transactions[item.transaction_id] || [];
      transaction.push(item);
      transactions[item.transaction_id] = transaction;
      return transactions;
    }, {});
    const refundTransactions = refundDetails.reduce(
      (refundTransactions, item) => {
        const transaction = refundTransactions[item.transaction_id] || [];
        transaction.push(item);
        refundTransactions[item.transaction_id] = transaction;
        return refundTransactions;
      },
      {}
    );
    let refundTotal = 0;
    refundDetails &&
      refundDetails.map((refund) => {
        refundTotal = refundTotal + refund.amount;
      });
    return (
      <>
        <style>
          {`
          table {
            border-spacing: 0;
          }
          th {
            padding: 10px;
            border-bottom: 1px dashed #e4e4e4;
            color:#0f1842;
            font-weight:300;
          }
          td {
            padding: 10px;
            text-align: center;
          }
        `}
        </style>
        <div
          style={{
            flex: 1,
            margin: "30px 10px",
            paddingRight: '50px',
          }}
        >
          <div
            style={{
              fontWeight: "600",
              marginBottom: 10,
              color: "#0f1842",
              fontSize: 18,
            }}
          >
            Transaction History
          </div>
          {!Object.keys(transactions).length ? (
            <div style={{ color: "grey", fontWeight: 400 }}>
              No Transaction History present
            </div>
          ) : (
            <div
              style={{
                flex: 1,
                padding: 15,
                display: "flex",
                borderRadius: 4,
                flexDirection: "column",
                backgroundColor: "#ffffff",
                boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
              }}
            >
              <table>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left" }}>Date</th>
                    <th style={{ textAlign: "left" }}>Mode</th>
                    <th style={{ textAlign: "right" }}>Amount</th>
                  </tr>
                </thead>
                <tbody
                  style={{ padding: 20, color: "grey", fontWeight: "300" }}
                  >
                  {Object.keys(transactions).map((transaction_id) => {
                    const total = transactions[transaction_id].reduce(
                      (sum, transaction) => (sum += transaction.amount),
                      0
                    );
                    return (
                      <>
                        <tr
                          key={feePaid.payment_id}
                          style={{ cursor: "pointer" }}
                        >
                          <td style={{ textAlign: "left" }}>
                            {moment(
                              transactions[transaction_id][0].payment_date
                            ).format("DD MMM 'YY")}
                          </td>
                          <td style={{ textAlign: "left" }}>
                            {
                              Object.keys(PAYMENT_TYPES)[
                                Object.values(PAYMENT_TYPES).indexOf(
                                  transactions[transaction_id][0].payment_type
                                )
                              ]
                            }
                          </td>
                          <td style={{ textAlign: "right" }}>
                            {convertToCurrencyFormat(total)}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                  {Object.keys(refundTransactions).map((transaction_id) => {
                    const total = refundTransactions[transaction_id].reduce(
                      (sum, transaction) => (sum += transaction.amount),
                      0
                    );
                    return (
                      <tr
                        key={refundDetails.payment_id}
                        style={{ cursor: "pointer" }}
                      >
                        <td style={{ textAlign: "left" }}>
                          {moment(
                            refundTransactions[transaction_id][0].refund_date
                          ).format("DD MMM 'YY")}
                        </td>
                        <td style={{ textAlign: "left" }}>
                            {
                              Object.keys(REFUND_PAYMENT_TYPES)[
                                Object.values(REFUND_PAYMENT_TYPES).indexOf(
                                  refundTransactions[transaction_id][0].payment_type
                                )
                              ]
                            }
                          </td>
                        <td style={{ textAlign: "right" }}>
                          -{convertToCurrencyFormat(total)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  fontWeight: "400",
                  borderTop: "1px dashed #e4e4e4",
                  padding: "15px 10px 0px 10px",
                  justifyContent: "space-between",
                  color: "#0f1842",
                }}
              >
                <div>Total</div>
                <div>{convertToCurrencyFormat(totalAmount - refundTotal)}</div>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }

  renderStudentDetails() {
    const { studentData } = this.props;
    const { totalFee, feePaid, refundDetails } = this.props;
    let amountPaid = 0,
      amount = 0,
      totalAmount = 0;
    feePaid.map((fee) => {
      amountPaid = amountPaid + parseInt(fee.amount, 10);
    });
    totalFee.map((fee) => {
      totalAmount = totalAmount + parseInt(fee.total_amount, 10);
    });
    refundDetails &&
      refundDetails.map((refund) => {
        amount = amount + refund.amount;
      });
    return (
      <div className="hide-in-print" style={{ margin: "30px 10px", paddingLeft: '50px' }}>
        <div
          style={{
            display: "flex",
            fontWeight: "600",
            marginBottom: 10,
            color: StyleConstants.color.darkBlue,
            fontSize: 20,
          }}
        >
          {studentData.first_name}
        </div>
        <div
          style={{
            display: "flex",
            padding: 20,
            borderRadius: 4,
            backgroundColor: "#ffffff",
            boxShadow: "0px 3px 5px rgba(65, 61, 74, 0.1)",
          }}
        >
          <div>
            <img src={avatar} width="112px" height="112px"></img>
          </div>
          <div style={{ marginLeft: 20, flex: 1 }}>
            <div
              style={{ borderTop: "1.7px dashed #e4e4e4", margin: "7px 0" }}
            ></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <div style={{ marginBottom: 5, display: 'flex' }}>
                  <span style={{ color: "grey", fontWeight: 300, width: 120 }}>
                    Father's Name:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {studentData.father_name}
                  </span>
                </div>
                <div style={{ marginBottom: 5, display: 'flex' }}>
                  <span style={{ color: "grey", fontWeight: 300, width: 120 }}>
                    Phone:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {studentData.phone}
                  </span>
                </div>
                <div style={{ marginBottom: 5, display: 'flex' }}>
                  <span style={{ color: "grey", fontWeight: 300, width: 120  }}>
                    Campus:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {studentData.campus_name}
                  </span>
                </div>
              </div>
              <div style={{ marginRight: 20 }}>
                <div style={{ marginBottom: 5, display: 'flex' }}>
                  <span style={{ color: "grey", fontWeight: "300", width: 100 }}>
                    Student ID:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {studentData.badge_id}
                  </span>
                </div>
                <div style={{ marginBottom: 5, display: 'flex' }}>
                  <span style={{ color: "grey", fontWeight: "300", width: 100 }}>
                    Date of Birth:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {studentData.dob && moment(studentData.dob).format("DD MM YYYY")}
                  </span>
                </div>
                <div style={{ marginBottom: 5, display: 'flex' }}>
                  <span style={{ color: "grey", fontWeight: "300", width: 100 }}>
                    Classroom:
                  </span>
                  <span style={{ color: StyleConstants.color.darkBlue }}>
                    {" "}
                    {studentData.classroom_name}
                  </span>
                </div>
              </div>
            </div>
            <div
              style={{
                borderTop: "1.7px dashed #e4e4e4",
                margin: "7px 0 10px 0",
              }}
            ></div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <span style={{ color: "grey", fontWeight: "300" }}>
                  Amount Paid:
                </span>
                <span style={{ color: "#32a87e" }}>
                  {convertToCurrencyFormat(amountPaid - amount)}
                </span>
              </div>
              <div style={{ marginRight: 20 }}>
                <span style={{ color: "grey", fontWeight: "300" }}>
                  Balance:
                </span>
                <span style={{ color: "#fd9f27" }}>
                  {" "}
                  {totalAmount
                    ? convertToCurrencyFormat(
                        totalAmount - (amountPaid - amount)
                      )
                    : 0}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }


  render() {
    const { feeDues, paymentSuccessful} = this.props;
    const { paymentConfirmationState, showConfirmationModal } = this.state;
    return (
      <div style={{ marginTop: 70 }}>
        <div style={{ display: "flex" }}>
          <div style={{ flex: 2 }}>
            {this.renderStudentDetails()}
            {feeDues.length!==0 && !paymentSuccessful && this.renderfees()}
            {feeDues.length===0 &&(
                  <div
                    style={{
                      color: "grey",
                      fontWeight: 400,
                      fontSize: 20,
                      textAlign: "center",
                      marginTop: "10%",
                    }}
                  >
                    No Fee Due present for Student
              </div>
            )}
            {paymentSuccessful && this.renderPaymentSuccessful()}
            {feeDues.length!==0 && !paymentSuccessful && this.renderMakePaymentButton()}
          </div>
        <div className="hide-in-print" style={{ flex: 1 }}>
            {!paymentConfirmationState && this.renderTransactions()}
          </div>
          {showConfirmationModal && !paymentSuccessful && this.renderConfirmationModal()}
        </div>
      </div>
    );
  }
}

ExternalFeePaymentPage.propTypes = {
  feeDues: PropTypes.array,
  feePaid: PropTypes.array,
  totalFee: PropTypes.array,
  classrooms: PropTypes.array,
  studentData: PropTypes.array,
  refundDetails: PropTypes.object,
  transactionId: PropTypes.string,
  paymentSuccessful: PropTypes.bool,
  onPaymentFailure: PropTypes.func.isRequired,
  updateSelectedDate: PropTypes.func.isRequired,
  selectedPaymentDate: PropTypes.string,
};

ExternalFeePaymentPage.defaultProps = {
  feeDues: [],
  feePaid: [],
  totalFee: [],
  refundDetails: [],
  feeNotes: [],
  studentData: [],
  feeBundles: [],
  feeAccounts: [],
  transactionId: "",
  paymentSuccessful: false,
  selectedPaymentDate: moment()
};

const mapStateToProps = ({ externalFeePayment }) => ({
  isLoading: externalFeePayment.isLoading,
  institutesList: externalFeePayment.institutesList,
  institute: externalFeePayment.institute,
  studentData: externalFeePayment.studentData,
  totalFee: externalFeePayment.totalFee,
  feeDues: externalFeePayment.feeDues,
  feePaid: externalFeePayment.feePaid,
  refundDetails: externalFeePayment.refundDetails,
  transactionId: externalFeePayment.transactionId,
  paymentSuccessful: externalFeePayment.paymentSuccessful,
  instituteId: externalFeePayment.instituteId,
  selectedStudentId: externalFeePayment.selectedStudentId,
});

export default withRouter(
  connect(mapStateToProps, { getStudentDetail, performSplitUpForExternal, changePaymentAmountForDue, captureRazorPayment, createRazorpayOrder })(ExternalFeePaymentPage)
);